<template>
    <div>
        <slot/>
    </div>
</template>

<script>
export default {
    name: "known-height-block",

    data() {
        return {
            height: 0
        }
    },

    mounted() {
        this.$nextTick(function(){
            this.height = this.$el.offsetHeight
            window.addEventListener("resize", this.onresize)
        })
    },

    destroyed() {
        window.removeEventListener("resize", this.onresize)
    },

    methods: {
        onresize(e) {
            this.height = this.$el.offsetHeight
        }
    },

    watch: {
        height() {
            this.$emit("height_changed", this.height)
        }
    }
}
</script>
